export const PathName = {
    home: "/home",
    about: "/about",
    podcast: "/podcast",
    gallery: "/gallery",
    achievers: "/achievers",
    contactUs: "/contactUs",
    register: "/register",
}